var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatBotChatSubmitButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3067_84988)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "#007CB0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7115 11.0467L26.7115 18.0467C27.0962 18.2262 27.0962 18.7733 26.7115 18.9528L11.7115 25.9528C11.2954 26.147 10.8596 25.7248 11.0405 25.3028L13.9561 18.4998L11.0405 11.6967C10.8596 11.2747 11.2954 10.8525 11.7115 11.0467ZM24.2464 18.999H14.8294L12.4756 24.4927L24.2464 18.999ZM12.4756 12.5068L14.8294 17.999H24.2464L12.4756 12.5068Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3067_84988"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatBotChatSubmitButton);
export default __webpack_public_path__ + "static/media/chat-bot-chat-submit-button.d0a78ccbda40cfa3d3d55643e8a9311f.svg";
export { ForwardRef as ReactComponent };